import styled, { css } from 'styled-components';

import { flexCenterAligned } from '@/styles/common';

export const CheckboxInput = styled.input`
  height: 0;
  width: 0;
  opacity: 0;
`;

export const CheckboxLabel = styled.label`
  position: relative;
  display: inline-flex;
  cursor: pointer;
`;

export const CheckboxIndicator = styled.div<{
  $isChecked: boolean;
  $isIndeterminate?: boolean;
  $isSecondary?: boolean;
}>`
  ${flexCenterAligned}
  width: 20px;
  height: 20px;
  border-radius: 5px;
  border: 1px solid
    ${({ $isSecondary }) =>
      $isSecondary ? 'var(--border-secondary)' : 'var(--border-main)'};
  background: var(--bg-main);
  transition: all 0.3s ease;

  ${({ $isChecked, $isIndeterminate }) =>
    ($isChecked || $isIndeterminate) &&
    css`
      background: var(--textAndLabels-main);
      border-color: var(--textAndLabels-main);
      & > svg * {
        stroke: var(--bg-main);
      }
    `}
`;
